import type { LogsInitConfiguration } from "@datadog/browser-logs";
import type { RumInitConfiguration } from "@datadog/browser-rum";
import config from "config/config";

export const rumConfig: RumInitConfiguration = {
  applicationId: config.datadog.applicationId,
  clientToken: config.datadog.clientToken,
  service: config.datadog.service,
  env: config.environment || "staging",
  sessionSampleRate: 100,
  site: "datadoghq.com",
  sessionReplaySampleRate: 100,
  allowedTracingUrls: [
    "https://api.production.boompay.app",
    "https://api.staging.boompay.app",
    "https://api.sandbox.boompay.app"
  ],
  version: config.buildId || "local", // Ensure buildId is defined, fallback to "unknown"
  trackResources: true,
  trackLongTasks: true,
  trackUserInteractions: true,
  defaultPrivacyLevel: "allow"
};
export const logsConfig: LogsInitConfiguration = {
  clientToken: config.datadog.clientToken,
  service: config.datadog.service,
  env: config.environment || "dev",
  forwardErrorsToLogs: true,
  forwardConsoleLogs: "all",
  version: config.buildId || "local", // Ensure buildId is defined, fallback to "local"
  forwardReports: "all",
  sessionSampleRate: 100,
  telemetrySampleRate: 100
};
